import type { ChartLayout } from "../renderers/layout";
import { xForIndex } from "../scales/timeScale";
import type { NormalizedBridgeChartData, NormalizedIndicatorSeries } from "../types/data";

export interface StudyPane {
  top: number;
  height: number;
}

export interface PanePoint {
  x: number;
  y: number;
  date: string;
  value: number;
}

export function studyPane(layout: ChartLayout, index: number, count: number): StudyPane {
  if (!Number.isInteger(index) || !Number.isInteger(count) || count < 1 || index < 0 || index >= count) {
    throw new RangeError("BridgeChart study pane bounds are invalid.");
  }
  const height = layout.volumeHeight / count;
  return { top: layout.volumeTop + height * index, height };
}

export function mapPanePoints(
  series: NormalizedIndicatorSeries,
  data: NormalizedBridgeChartData,
  start: number,
  end: number,
  layout: ChartLayout,
  pane: StudyPane
): PanePoint[] {
  const visible = series.points.filter(point => {
    const index = data.dateIndex[point.date];
    return index !== undefined && index >= start && index <= end;
  });
  if (visible.length === 0) return [];
  let min = Math.min(...visible.map(point => point.value));
  let max = Math.max(...visible.map(point => point.value));
  if (series.code === "VOLUME") min = 0;
  if (series.code === "RSI_14") { min = 0; max = 100; }
  if (min === max) { min -= 1; max += 1; }
  const padding = (max - min) * 0.08;
  min -= padding;
  max += padding;
  return visible.map(point => ({
    x: xForIndex(layout, start, end, data.dateIndex[point.date]),
    y: pane.top + 4 + (max - point.value) / (max - min) * Math.max(1, pane.height - 8),
    date: point.date,
    value: point.value
  }));
}
